import(/* webpackMode: "eager", webpackExports: ["Partner"] */ "/app/src/components/index.tsx");
